const { getElement, trapFocus, disableTrapFocus } = window.BAO.Utils

export class SiteDrawer extends window.BAO.CustomElement({
  SuperClass: HTMLElement,
}) {
  constructor() {
    super()

    this.drawers = getElement('site-drawers')
    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }
    this.drawers.drawers.push(this)

    // this.inert = true
    this._isOpen = false
    this._headerEl = null
  }

  connectedCallback() {
    super.connectedCallback()
  }

  get key() {
    return this.getAttribute('key')
  }

  get elements() {
    return {
      trigger: getElement(`[data-drawers-trigger=${this.key}]`),
      close: getElement(`[data-module-drawers-close=${this.key}]`),
    }
  }

  get isOpen() {
    return this._isOpen
  }

  set isOpen(val) {
    this._isOpen = val

    this.classList.toggle(this.config.classes.activeDrawerClass, val)

    if (val) {
      this.show()
      if (this.getAttribute('key') === 'menu') {document.querySelector('.section-header').classList.add('mobile-menu-open')}
    } else {
      this.close()
      if (this.getAttribute('key') === 'menu') {document.querySelector('.section-header').classList.remove('mobile-menu-open')}
    }
  }

  show() {
    this.setAttribute('open', '')
    this.setPosTop()
  }

  close() {
    this.removeAttribute('open')
  }

  setPosTop() {
    this._headerEl = this._headerEl ?? document.querySelector('.section-header')

    if (this._headerEl) {
      const headerRect = this._headerEl.getBoundingClientRect()
      this.style.setProperty('--Header_Height', `${headerRect.bottom}px`)
    }
  }

  get config() {
    return {
      classes: {
        activeDrawerClass: 'drw-Drawer-active',
      },
    }
  }
}

export class SiteDrawerDialog extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  constructor() {
    super()

    this.drawers = getElement('site-drawers')
    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }
    this.drawers.drawers.push(this)

    this.inert = true
    this._isOpen = false
    this._headerEl = null
  }

  connectedCallback() {
    super.connectedCallback()
  }

  get key() {
    return this.getAttribute('key')
  }

  get elements() {
    return {
      trigger: getElement(`[data-drawers-trigger=${this.key}]`),
      close: getElement(`[data-module-drawers-close=${this.key}]`),
    }
  }

  get isOpen() {
    return this._isOpen
  }

  set isOpen(val) {
    this._isOpen = val

    this.classList.toggle(this.config.classes.activeDrawerClass, val)

    if (val) {
      if (!this.hasAttribute('open')) {

        this.addAcceleratedButtons()

        this.inert = false
        this.showModal()
        // showModal() only handles initial focus - it doesn't loop Tab at
        // the boundaries, so focus can escape to the page behind the still-
        // open dialog once you reach the last focusable element.
        trapFocus(this)
      }
    } else {
      if (this.hasAttribute('open')) {
        this.inert = true
        this.close()
        disableTrapFocus()
        // close() doesn't restore focus on its own - without this, focus is
        // left on the (now hidden) close button or falls back to <body>.
        this.elements.trigger?.focus()
      }
    }
  }

  setPosTop() {
    this._headerEl = this._headerEl ?? document.querySelector('.section-header')

    if (this._headerEl) {
      const headerRect = this._headerEl.getBoundingClientRect()
      this.style.setProperty('--Header_Height', `${headerRect.bottom}px`)
    }
  }

  // ABTEST ACCELERATED BUTTONS IN CART - START
  addAcceleratedButtons () {
    if (this.id === 'push-cart' && this.hasAttribute('data-abtest-cartaccelerated-testid') && !this.querySelector('.psh-CartFooter_Buttons shopify-accelerated-checkout-cart')) {
      const variantID = this.getAttribute('data-abtest-cartaccelerated-testid')
          
      function waitForShoplift (callback, maxAttempts = 50) {
        let attempts = 0

        function check () {
          if (window.shoplift) {
            callback(window.shoplift)
          } else if (attempts < maxAttempts) {
            attempts++
            setTimeout(check, 100)
          } else {
            console.warn('Shoplift did not load within the expected time.')
          }
        }
        check()
      }

      waitForShoplift(async shoplift => {
        const testUser = await shoplift.isHypothesisActive(variantID)
        if (testUser) {
          fetch('/?section_id=abtest-acceleratedbuttons')
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser()
            const doc = parser.parseFromString(html, 'text/html')
            const content = doc.querySelector('#shopify-section-abtest-acceleratedbuttons')

            const walletCart = content.querySelector('shopify-accelerated-checkout-cart')
            if (walletCart) {
              const canUseApplePay = Boolean(window.ApplePaySession && window.ApplePaySession.canMakePayments())
              const walletPriority = canUseApplePay ? ['apple_pay', 'shop_pay', 'paypal'] : ['shop_pay', 'paypal']
              const walletConfigs = JSON.parse(walletCart.getAttribute('wallet-configs') || '[]')
              const winner = walletPriority.find(name => walletConfigs.some(config => config.name === name)) || walletConfigs[0]?.name

              if (winner) {
                walletCart.setAttribute('wallet-configs', JSON.stringify(walletConfigs.filter(config => config.name === winner)))

                const winnerSlot = winner.replace('_', '')
                Array.from(walletCart.children).forEach(child => {
                  const slot = (child.getAttribute('slot') || '').replace('button-', '').toLowerCase()
                  if (slot !== winnerSlot) child.remove()
                })
              }
            }

            this.querySelector('.psh-CartFooter_Buttons').insertAdjacentHTML('beforeend', content.innerHTML)
            setTimeout(() => {
              this.querySelector('.ctl.mobile').style.bottom = this.querySelector('.drw-Drawer_Footer').clientHeight + 'px'
            }, 100)
            
          })
        }
      })
    }
  }
  // ABTEST ACCELERATED BUTTONS IN CART - END

    
  get config() {
    return {
      classes: {
        activeDrawerClass: 'drw-Drawer-active',
      },
    }
  }
}

// Register without extending built-in element
customElements.define('site-drawer', SiteDrawer)
customElements.define('site-drawer-dialog', SiteDrawerDialog, { extends: 'dialog' })

